import React, { useContext } from "react";
import { Box, Button, Skeleton, Tooltip, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CheckCircleRounded, Verified } from "@mui/icons-material";
import { AccountDetailContext } from "@pages/Assets/Account/context";
import { Account } from "@services/account/types";
import { differenceInDays } from "date-fns";
import {
  CertificationAboutToExpire,
  CertificationExpired,
} from "@assets/icons";

const activeLicense = "The License is active.";
const expiredLicense = "The License has expired.";
const aboutToExpireLicense = "The License is about to expire.";
const noLicense = "No License.";

const getLicensing = (account?: Account) => {
  let license: { label: string; icon: React.JSX.Element | undefined } = {
    label: noLicense,
    icon: undefined,
  };
  if (account?.accountEntitlementOptions === undefined) {
    license = { label: noLicense, icon: undefined };
  } else if (
    (account.accountEntitlementOptions.dateExpired ?? 0) > new Date().getTime()
  ) {
    if (
      differenceInDays(
        account?.accountEntitlementOptions?.dateExpired ?? 0,
        Date.now()
      ) < 14
    ) {
      license = {
        icon: (
          <CertificationAboutToExpire
            sx={({ palette }) => ({ color: palette.warning.main })}
          />
        ),
        label: aboutToExpireLicense,
      };
    } else {
      license = {
        icon: (
          <Verified sx={({ palette }) => ({ color: palette.success.main })} />
        ),
        label: activeLicense,
      };
    }
  } else if (
    (account.accountEntitlementOptions.dateExpired ?? 0) < new Date().getTime()
  ) {
    license = {
      icon: (
        <CertificationExpired
          sx={({ palette }) => ({ color: palette.error.main })}
        />
      ),
      label: expiredLicense,
    };
  }

  return license;
};

const AccountLicense = () => {
  const account = useContext(AccountDetailContext);
  const { t } = useTranslation();

  if (account === undefined)
    return (
      <Skeleton
        variant="circular"
        sx={{ height: "1.5rem", width: "1.5rem", alignSelf: "center" }}
      >
        <CheckCircleRounded />
      </Skeleton>
    );
  const license = getLicensing(account);
  return (
    <Tooltip title={t(license.label)} arrow>
      <Box
        sx={{
          backgroundColor: ({ palette }) => palette.background.highlight,
          borderRadius: "50%",
          width: "1.5rem",
          height: "1.5rem",
        }}
      >
        <Box> {license.icon}</Box>
      </Box>
    </Tooltip>
  );
};

export default AccountLicense;
